import type { ReactNode } from 'react';
import { useEffect } from 'react';

/** Cabeçalho padrão de página: título, contexto à direita e ações. */
export function Pagina({
  titulo,
  contexto,
  acoes,
  children,
  larga = false,
}: {
  titulo: string;
  contexto?: ReactNode;
  acoes?: ReactNode;
  children: ReactNode;
  /** Sem margem lateral extra (tabelas largas). */
  larga?: boolean;
}) {
  useEffect(() => {
    document.title = `${titulo} · Precificador Biopol`;
  }, [titulo]);

  return (
    <div className="flex min-h-full flex-col">
      <header className={`flex flex-wrap items-end justify-between gap-3 pt-6 pb-4 ${larga ? 'px-4' : 'px-6'}`}>
        <div className="min-w-0">
          <h1 className="text-xl leading-7 font-semibold">{titulo}</h1>
          {contexto && <div className="mt-0.5 text-tinta-2">{contexto}</div>}
        </div>
        {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
      </header>
      <div className={`flex-1 pb-8 ${larga ? 'px-4' : 'px-6'}`}>{children}</div>
    </div>
  );
}

export function Carregando({ texto = 'Carregando…' }: { texto?: string }) {
  return (
    <p role="status" className="py-10 text-center text-tinta-2">
      {texto}
    </p>
  );
}
